import ANDROID_LISTEN_METHOD from './interface';
import ANDROID_BRIDGE_METHOD from './method';

const USER_INFO = require('../../user-info.json');

/**
 * @description: 初始化安卓 SDK
 */

const ANDROID_SDK_INIT = () => {
  if (window.bridge) {
    if (window.bridge.setMethodList) {
      const METHOD_LIST_STRING = JSON.stringify(Object.values(ANDROID_LISTEN_METHOD));

      window.bridge.setMethodList(METHOD_LIST_STRING);
    }
  } else {
    console.log('window.bridge does not exist!');
  }
};

/**
 * @description: 安卓桥接对象注册事件回调方法
 * @param {string} event - 时间名称
 * @param {object} callback - 回调函数
 * @return: void
 */

const ANDROID_REGISTER = (event, callback) => {
  try {
    if (window.bridge) {
      console.log('event', event);
      window.bridge[event] = callback;
    }
  } catch (e) {
    console.log(e);
  }
};

/**
 * @description: js 调用 window.bridge 原生方法
 * @param {string} functionName - 方法名
 * @param {string} params - 参数
 * @return: *
 */

const ANDROID_APP_CALL = (functionName, ...params) => {
  try {
    if (window.bridge) {
      return window.bridge[functionName](...params);
    } else {
      return handleNoBridge(functionName, ...params);
    }
  } catch (e) {
    console.log(e, 'functionName:', functionName);
  }
};

/**
 * @description: 处理本地开发，没有 window.bridge 的情况
 * @param {string} functionName - 方法名
 * @param {any} params - 参数
 */

const handleNoBridge = (functionName, params) => {
  switch (functionName) {
    case 'openPageWithJSON':
      // console.log(`openPageWithJSON`, JSON.parse(params).url);
      window.location.href = JSON.parse(params).url;
      break;
    case 'getUserInfo':
      if (process.env.NODE_ENV === 'development') {
        return JSON.stringify(USER_INFO);
      }
      break;
    case 'setTitle':
      document.title = params;
      break;
    case 'jumpByUrl':
      console.log({ ...params });
      break;
    default:
    // throw Error('window.bridge is not defined!');
  }
};

export { ANDROID_SDK_INIT, ANDROID_REGISTER, ANDROID_APP_CALL, ANDROID_LISTEN_METHOD, ANDROID_BRIDGE_METHOD };
